import { useTranslate } from '@va/localization';
import { GrayGradientDivider, ModalHeader } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import classNames from 'classnames';
import {
  CustomDashboardDomainCreationContextParams,
  CustomDashboardDomainCreationContextProvider,
  CustomDashboardDomainCreationStep,
  useCustomDashboardDomainCreationContext,
} from './customDashboardDomainCreationContext';
import { ConfirmEffectsStep } from './steps/ConfirmEffectsStep';
import { VerifyDnsStep } from './steps/VerifyDnsStep';

export const CustomDashboardDomainCreationModal = ({
  isOpen,
  closeModal,
  domain,
  onSuccess,
  customDomainId,
}: {
  isOpen: boolean;
} & CustomDashboardDomainCreationContextParams) => {
  const translate = useTranslate();

  return (
    <ModalWrapper closeModal={closeModal} isModalOpen={isOpen}>
      <ModalHeader
        title={translate('standalone.customPlatformDomain.confirmDomainChange.title')}
        onClose={closeModal}
        className={'overflow-hidden'}
        titleClassName={'truncate'}
      />
      <CustomDashboardDomainCreationContextProvider
        customDomainId={customDomainId}
        onSuccess={onSuccess}
        closeModal={closeModal}
        domain={domain}
      >
        <ModalContent />
      </CustomDashboardDomainCreationContextProvider>
    </ModalWrapper>
  );
};

const ModalContent = () => {
  const { activeStep } = useCustomDashboardDomainCreationContext();

  return (
    <div className={classNames('max-w-[46.875rem] w-screen')}>
      <GrayGradientDivider />
      {activeStep === CustomDashboardDomainCreationStep.verifyDNS && <VerifyDnsStep />}
      {activeStep === CustomDashboardDomainCreationStep.confirmEffects && <ConfirmEffectsStep />}
    </div>
  );
};
